import { render, staticRenderFns } from "./Jsonb.vue?vue&type=template&id=114ea888&"
import script from "./Jsonb.vue?vue&type=script&lang=js&"
export * from "./Jsonb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports